import * as React from 'react';

import URI from 'jsuri';
import PropTypes from 'prop-types';
import Q from 'q';
import _ from 'underscore';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import API from 'js/lib/api';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import getPropsFromPromise from 'js/lib/getPropsFromPromise';

import { Avatar, Button } from '@coursera/cds-core';

import ForumsConnectedReplyCMLInput from 'bundles/discussions/components/repliesList/ForumsConnectedReplyCMLInput';
import { answerSorts } from 'bundles/discussions/constants';
import { buildUrlForDiscussionPrompt } from 'bundles/discussions/utils/discussionsUrl';
import { formatCount } from 'bundles/discussions/utils/threadUtils';
import Icon from 'bundles/iconfont/Icon';

import _t from 'i18n!nls/discussions';

const NUM_RESPONDER_IMAGES = 4;

class RespondedLearnersImageBaseComponent extends React.Component {
  static propTypes = {
    responseCount: PropTypes.number.isRequired,
    answers: PropTypes.array,
  };

  renderMorePeopleImage() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'responseCount' does not exist on type 'R... Remove this comment to see the full error message
    if (this.props.responseCount > NUM_RESPONDER_IMAGES) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'responseCount' does not exist on type 'R... Remove this comment to see the full error message
      const total = formatCount(this.props.responseCount - NUM_RESPONDER_IMAGES, true);
      return (
        <li className="bgcolor-black-g5">
          <div className="horizontal-box align-items-absolute-center num-responder-images caption-text">+{total}</div>
        </li>
      );
    } else {
      return null;
    }
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'answers' does not exist on type 'Readonl... Remove this comment to see the full error message
    const { answers } = this.props;
    const repliedLearners =
      answers &&
      answers
        .filter((item: $TSFixMe, index: $TSFixMe) => index < NUM_RESPONDER_IMAGES)
        .map((item: $TSFixMe) => {
          return {
            image: item.creator?.photoUrl,
            name: item.creator?.fullName,
          };
        });

    if (!repliedLearners || repliedLearners.length === 0) {
      return null;
    }

    return (
      <ul className="nostyle horizontal-box align-items-absolute-center learner-image-list" aria-hidden="true">
        {repliedLearners.map(({ name, image }: $TSFixMe) => {
          return (
            <li key={name}>
              <Avatar
                variant="user"
                initial={name}
                size={36}
                imgProps={{
                  src: image,
                }}
              />
            </li>
          );
        })}

        {this.renderMorePeopleImage()}
      </ul>
    );
  }
}

class Input extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    question: PropTypes.object.isRequired,
    savingState: PropTypes.string.isRequired,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
    const { question, savingState, placeholder } = this.props;

    return (
      <div className="horizontal-box align-items-left theme-light c-prompt-card">
        <ForumsConnectedReplyCMLInput
          hideFollow
          question={question}
          parentPost={question}
          savingState={savingState}
          placeholder={_t(placeholder)}
        />
      </div>
    );
  }
}

class Saving extends React.Component {
  render() {
    return (
      <div className="horizontal-box align-items-absolute-center bgcolor-white c-prompt-card color-hint-text">
        <Icon name="spinner" className="cif-spin" />
        <span className="caption-text">{_t('Submitting Your Response')}</span>
      </div>
    );
  }
}

class CompletedBaseComponent extends React.Component {
  static propTypes = {
    showLink: PropTypes.bool,
    questionId: PropTypes.string.isRequired,
    // from HOC
    url: PropTypes.string,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'url' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
    const { url } = this.props;
    return (
      <div className="vertical-box align-items-absolute-center bgcolor-white c-prompt-card" role="alert">
        <span className="color-secondary-text">
          {_t('Your response has been submitted. Engage and discuss with other learners below!')}
        </span>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'url' does not exist on type 'Readonly<{}... Remove this comment to see the full error message */}
        {this.props.url && (
          <>
            <br />
            <Button variant="secondary" component="a" href={url}>
              {_t('View My Response')}
            </Button>
          </>
        )}
      </div>
    );
  }
}

const DiscussionPromptComponents = {
  Input,
  Saving,
  Completed: _.compose(
    getPropsFromPromise((props: $TSFixMe) => {
      if (props.showLink) {
        const api = API('/api/onDemandCourseForumAnswers.v1/', {
          type: 'rest',
        });

        const userCourseQuestionId = [props.userId, props.courseId, props.questionId].join('~');
        const byQuestionAndUser = new URI()
          .addQueryParam('q', 'byForumQuestionId')
          .addQueryParam('userCourseQuestionId', userCourseQuestionId)
          .addQueryParam('sort', 'createdAtAsc')
          .addQueryParam('creatorId', props.userId)
          .toString();

        return Q(api.get(byQuestionAndUser)).then((response) => {
          if (!response.elements.length) {
            // can occur when the user switches sessions or branches.
            return {
              url: undefined,
            };
          }

          const urlForDiscussionPrompt = buildUrlForDiscussionPrompt(response.elements[0].forumAnswerId);

          return {
            url: urlForDiscussionPrompt,
          };
        });
      } else {
        return Q({
          url: undefined,
        });
      }
    })
  )(CompletedBaseComponent),
  RespondedLearnersImage: _.compose(
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type '{}'.
    connectToStores(['ThreadDetailsStore'], ({ ThreadDetailsStore }, { questionId, page }) => {
      return {
        answers: ThreadDetailsStore.getReplies(questionId, page, answerSorts.newestSort) || [],
      };
    })
  )(RespondedLearnersImageBaseComponent),
};

export { Input, Saving };

export const { Completed, RespondedLearnersImage } = DiscussionPromptComponents;

export default DiscussionPromptComponents;
